import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { useToast } from '@/shared/hooks/useToast';
import { useTranslation } from 'react-i18next';
import { tasksService } from '../api/tasks.service';
import { TASK_KEYS } from './queryKeys';
import type { CopyTaskApiRequest, CopyTaskResponse, Task } from '../types';

export function useCopyTask(taskId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;
  const { t } = useTranslation('tasks');
  const { toast } = useToast();

  return useMutation<CopyTaskResponse, Error, CopyTaskApiRequest>({
    mutationFn: (payload: CopyTaskApiRequest) => tasksService.copyTask(taskId, payload),

    onSuccess: () => {
      toast.success({ title: t('copy.successToast') });
      const entity = queryClient.getQueryData<Task>(TASK_KEYS.entity(orgId, taskId));
      const targetKey = entity?.projectId
        ? TASK_KEYS.projectRoot(orgId, entity.projectId)
        : TASK_KEYS.byOrg(orgId);
      queryClient.invalidateQueries({ queryKey: targetKey });
    },
  });
}
